// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__R1odI","inputWrapper":"styles_inputWrapper__Ruj_Q","input":"styles_input__G8Ik8","placeholder":"styles_placeholder__4EcWf"};